import React from "react";
import { useSnackbar } from "notistack";
import { Typography, TableContainer, Paper, Table, TableHead, TableRow, TableCell, Hidden, TableBody } from "@material-ui/core";
import { LoadingComponent } from "../loading/LoadingComponent";
import { useAuctionsWon } from "../../services/AuctionService";
import { WinHistoryRow } from "./WinHistoryRow";
import * as Styles from "./styles/WinHistoryStyles";

export const WinHistoryComponent: React.FC = () => {
  const classes = Styles.WinHistoryStyles();

  const { enqueueSnackbar } = useSnackbar();

  const [winHistory, loadingWinHistory] = useAuctionsWon(statusCode => {
    if (statusCode !== 401) {
      enqueueSnackbar("There was a problem loading your won auctions, please try again.", { variant: "error" });
    }
  });

  return (
    <>
      <Typography variant="h4" component="h1" gutterBottom>
        Auctions won
      </Typography>
      <Typography variant="subtitle1" component="h2" gutterBottom className={classes.headerPadding}>
        This page can be used to view your all auctions you have won.
      </Typography>
      {loadingWinHistory && winHistory === null && <LoadingComponent label="Loading your auctions" />}
      {!loadingWinHistory && winHistory && (
        <TableContainer component={Paper}>
          <Table aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Image</TableCell>
                <TableCell>Title</TableCell>
                <Hidden smDown>
                  <TableCell>Auction End</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Amount</TableCell>
                </Hidden>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {winHistory.length === 0 && (
                <TableRow>
                  <TableCell colSpan={3}>
                    <Typography variant="subtitle1" component="h2">
                      You have not won any auctions.
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
              {winHistory?.map((won, index) => (
                <TableRow key={index}>
                  <WinHistoryRow auctionListing={won} />
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </>
  );
};
